import {
  deserializeHtml,
  createPlateUIEditor,
  parseHtmlDocument,
} from '@udecode/plate';

import { plugins } from '../contexts/editorField';

const deserializeString = (string) => {
  // Deserialize html from element variable, if exists.
  let fragment;
  // Carriage returns can get weird if the incoming string is from a template
  // with merge fields.
  const modifiedString = string.replace(/[\n\r]/g, '<br />');
  const parsedDocument = parseHtmlDocument(modifiedString);
  if (parsedDocument) {
    fragment = deserializeHtml(
      createPlateUIEditor({ plugins }),
      { element: parsedDocument.body },
    );

    return [{
      type: 'p',
      children: fragment,
    }];
  }
  return [];
};

export default deserializeString;
